export default __webpack_public_path__ + "static/media/accounts-icon.babc1ba8.svg";